import styled from '@emotion/styled'

export const StyledWrapper = styled('div')`
  position: relative;
  width: 100%;
  &.dropDown {
    .rc-tree-select {
      padding-left: 0;
      padding-right: 24px;
    }
    .rc-tree-select-selector {
      padding: 0 4px;
    }
  }
  input {
    padding-right: 24px;
  }
  &:hover {
    .clear-icon {
      display: flex;
    }
  }
`

export const StyledIcon = styled.div`
  cursor: pointer;
  width: 16px;
  height: 16px;
  background: var(--ow-color-neutral-300);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translateY(-50%);
  display: none;
`
